import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  HStack,
  Text,
  Badge,
} from '@chakra-ui/react';
import { FaChevronDown, FaFlask, FaBookOpen, FaQuestionCircle, FaCreditCard, FaFileAlt, FaGraduationCap } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const NavDropdowns = () => {
  const { user } = useAuth();
  const pricingTo = user ? '/buy-credits' : '/pricing';
  return (
    <HStack spacing={1}>
      <Menu>
        <MenuButton
          as={Button}
          variant="ghost"
          size="sm"
          rightIcon={<FaChevronDown />}
          fontWeight="medium"
          color="gray.700"
          _hover={{ bg: 'gray.100' }}
          _active={{ bg: 'gray.100' }}
        >
          Features
        </MenuButton>
        <MenuList shadow="lg" border="1px" borderColor="gray.200" py={2} minW="200px">
          <MenuItem
            as={RouterLink}
            to="/examples"
            icon={<Icon as={FaFlask} color="blue.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            <HStack spacing={2}>
              <Text>Templates</Text>
            </HStack>
          </MenuItem>
          {/* Copilot temporarily hidden — functionality still in development
          <MenuItem
            as={RouterLink}
            to="/copilot-intro"
            icon={<Icon as={FaBrain} color="purple.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            <HStack spacing={2}>
              <Text>Copilot</Text>
              <Badge colorScheme="orange" variant="subtle" fontSize="2xs">Beta</Badge>
            </HStack>
          </MenuItem>
          */}
          <MenuItem
            as={RouterLink}
            to="/tutorial"
            icon={<Icon as={FaBookOpen} color="green.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            Getting Started
          </MenuItem>
          <MenuItem
            as={RouterLink}
            to="/learning-guide"
            icon={<Icon as={FaGraduationCap} color="teal.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            <HStack spacing={2}>
              <Text>Learning Guide</Text>
              <Badge colorScheme="teal" variant="subtle" fontSize="2xs">New</Badge>
            </HStack>
          </MenuItem>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton
          as={Button}
          variant="ghost"
          size="sm"
          rightIcon={<FaChevronDown />}
          fontWeight="medium"
          color="gray.700"
          _hover={{ bg: 'gray.100' }}
          _active={{ bg: 'gray.100' }}
        >
          Resources
        </MenuButton>
        <MenuList shadow="lg" border="1px" borderColor="gray.200" py={2} minW="200px">
          <MenuItem
            as={RouterLink}
            to="/executive-brief"
            icon={<Icon as={FaFileAlt} color="brand.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            Executive brief
          </MenuItem>
          <MenuItem
            as={RouterLink}
            to="/faq"
            icon={<Icon as={FaQuestionCircle} color="orange.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            FAQ
          </MenuItem>
          <MenuItem
            as={RouterLink}
            to={pricingTo}
            icon={<Icon as={FaCreditCard} color="green.500" />}
            fontSize="sm"
            py={2}
            _hover={{ bg: 'gray.50' }}
          >
            Pricing
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
};

export default NavDropdowns;
